type Props = {
  total: number;
  realIdx: number;
  onSelect: (i: number) => void;
};

export function SaleListBannerIndicator({ total, realIdx, onSelect }: Props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: 6, padding: '8px 0' }}>
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          onClick={() => onSelect(i)}
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: i === realIdx ? '#fff' : 'rgba(255,255,255,0.5)',
            transition: 'background-color 0.3s',
            cursor: 'pointer',
          }}
        />
      ))}
    </div>
  );
}
